<template>
  <div>
    <div v-if="showProvince" class="columns relative mx-1">
      <div
        :style="{
          backgroundImage: `url(${provinceObject.banner_image})`
        }"
        class="banner"
      >
        <div
          class="columns container is-full-width has-padding-left-50-mobile has-padding-right-50-mobile py-10 z-index relative has-padding-right-80 has-padding-left-80"
        >
          <div class="column text-color margin-auto pl-0">
            <h3
              class="has-text-weight-semibold is-size-3 is-size-4-mobile has-text-centered-mobile"
            >
              {{ $t(provinceObject.text) }}
            </h3>
          </div>
          <div
            class="column map has-text-centered is-hidden-mobile is-flex d-placecontent"
          >
            <img
              :src="provinceObject.sub_image"
              alt="province-image"
              class="margin-auto"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="container has-margin-top-25 has-padding-left-15-mobile has-padding-right-15-mobile"
      :class="screen === 'mobile' ? '' : 'padding-right-80px padding-left-80px'"
    >
      <div id="job-lists" class="columns is-multiline my-2">
        <div class="column is-12">
          {{
            $t('foundJobMatches', [
              get($store.state.collection.collectionResponses, [
                'jobSearchCollection',
                'count'
              ]) || 0,
              noOfVacancyForJobPost
            ])
          }}
        </div>
        <client-only>
          <div
            class="column is-4"
            :class="screen === 'mobile' ? 'mobile-hide' : ''"
          >
            <div class="card">
              <div>
                <div class="pointer card-header-title is-size-5">
                  <span
                    v-if="screen === 'mobile'"
                    class="is-size-6"
                    @click="expansionControl('expansion')"
                  >
                    {{ $t('Click here to refine search') }}
                  </span>
                  <span v-else @click="expansionControl('expansion')">
                    {{ $t('Refine your search') }}
                  </span>
                  <a
                    v-if="showClearSearch && expansionController.expansion"
                    class="is-size-7 has-margin-left-auto"
                    @click="clearSearch"
                    >{{ $t('Clear Search') }}</a
                  >
                  <vue-icon-base
                    v-if="!expansionController.expansion"
                    class="has-margin-left-auto"
                    height="16"
                    width="16"
                    :path="$options.icons[$kc('uni-filter')]"
                  ></vue-icon-base>
                </div>
                <div v-if="expansionController.expansion">
                  <div>
                    <div
                      class="pointer card-header-title is-size-6 has-text-weight-medium columns is-bottom-marginless is-bottom-paddingless"
                      @click="expansionControl('jobPreference')"
                    >
                      <div class="column is-10">{{ $t('Job Preference') }}</div>
                      <div class="column is-2 has-text-right is-size-5">
                        <vue-icon-base
                          v-if="expansionController.jobPreference"
                          height="16"
                          width="16"
                          :path="$options.icons[$kc('uni-minus-circle')]"
                        ></vue-icon-base>
                        <vue-icon-base
                          v-else
                          height="16"
                          width="16"
                          :path="$options.icons[$kc('uni-plus-circle')]"
                        ></vue-icon-base>
                      </div>
                    </div>
                    <transition name="slide-fade">
                      <div v-show="expansionController.jobPreference">
                        <div
                          class="columns card-content is-multiline has-padding-top-10 has-padding-bottom-10"
                        >
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-list-ui-alt')]"
                                ></vue-icon-base>
                                {{ $t('jobCategory') }}
                              </label>
                              <div>
                                <vue-auto-complete
                                  v-model="filterFields.categories"
                                  extra-input-class="is-small"
                                  item-text="name"
                                  item-value="slug"
                                  endpoint="/api/v1/common/job-categories/"
                                  allow-multiple
                                ></vue-auto-complete>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-list-ui-alt')]"
                                ></vue-icon-base>
                                {{ $t('Province') }}
                              </label>
                              <div>
                                <vue-auto-complete
                                  v-model="filterFields.province"
                                  extra-input-class="is-small"
                                  :item-text="
                                    $i18n.locale == 'ne' ? 'name_ne' : 'name'
                                  "
                                  item-value="id"
                                  endpoint="/api/v1/common/province"
                                ></vue-auto-complete>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="filterFields.province"
                            class="column is-12 px-2"
                          >
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-list-ui-alt')]"
                                ></vue-icon-base>
                                {{ $t('District') }}
                              </label>
                              <div>
                                <vue-auto-complete
                                  v-model="filterFields.district"
                                  extra-input-class="is-small"
                                  :item-text="
                                    $i18n.locale == 'ne' ? 'name_ne' : 'name'
                                  "
                                  item-value="id"
                                  endpoint="/api/v1/common/district"
                                  :extra-filter="{
                                    province: filterFields.province
                                  }"
                                ></vue-auto-complete>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="
                              filterFields.province && filterFields.district
                            "
                            class="column is-12 px-2"
                          >
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-list-ui-alt')]"
                                ></vue-icon-base>
                                {{ $t('Municipality / VDC') }}
                              </label>
                              <div>
                                <vue-auto-complete
                                  v-model="filterFields.locations"
                                  extra-input-class="is-small"
                                  :item-text="
                                    $i18n.locale == 'ne' ? 'name_ne' : 'name'
                                  "
                                  item-value="id"
                                  endpoint="/api/v1/common/cities/"
                                  :extra-filter="{
                                    district: filterFields.district
                                  }"
                                  filter-by="default_name"
                                ></vue-auto-complete>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-sitemap')]"
                                ></vue-icon-base>
                                {{ $t('Job Level') }}
                              </label>
                              <div>
                                <auto-complete
                                  v-model="filterFields.job_level"
                                  :items="$options.jobLevelChoices"
                                  item-text="name"
                                  extra-input-class="is-small"
                                  item-value="value"
                                  allow-multiple
                                ></auto-complete>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-clock')]"
                                ></vue-icon-base>
                                {{ $t('Preferred Shift') }}
                              </label>
                              <div>
                                <auto-complete
                                  v-model="filterFields.preferred_shift"
                                  extra-input-class="is-small"
                                  :items="$options.preferredShitChoices"
                                  item-text="name"
                                  item-value="value"
                                  allow-multiple
                                ></auto-complete>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-money-bill')]"
                                ></vue-icon-base>
                                {{ $t('Expected Salary') }}
                              </label>
                              <div class="control pl-5 is-size-8 has-text-grey">
                                <label class="radio">
                                  <input
                                    v-model="salaryOptions"
                                    value="firstOption"
                                    :checked="salaryOptions === 'firstOption'"
                                    type="radio"
                                    name="salary"
                                    @change="getSalaryFilter(0, 15000)"
                                  />
                                  {{
                                    `${$t('Rs')}. ${$t('15000')} ${$t(
                                      'or less'
                                    )}`
                                  }}
                                </label>
                                <br />
                                <label class="radio">
                                  <input
                                    v-model="salaryOptions"
                                    value="secondOption"
                                    :checked="salaryOptions === 'secondOption'"
                                    type="radio"
                                    name="salary"
                                    @change="getSalaryFilter(15001, 25000)"
                                  />
                                  {{ $t('Rs') }}. {{ $t('15001') }} -
                                  {{ $t('Rs') }}. {{ $t('25000') }}
                                </label>
                                <br />
                                <label class="radio">
                                  <input
                                    v-model="salaryOptions"
                                    value="thirdOption"
                                    type="radio"
                                    :checked="salaryOptions === 'thirdOption'"
                                    name="salary"
                                    @change="getSalaryFilter(25001, 35000)"
                                  />
                                  {{ $t('Rs') }}. {{ $t('25001') }} -
                                  {{ $t('Rs') }}. {{ $t('35000') }}
                                </label>
                                <br />
                                <label class="radio">
                                  <input
                                    v-model="salaryOptions"
                                    type="radio"
                                    value="fourthOption"
                                    :checked="salaryOptions === 'fourthOption'"
                                    name="salary"
                                    @change="getSalaryFilter(35001, 50000)"
                                  />
                                  {{ $t('Rs') }}. {{ $t('35001') }} -
                                  {{ $t('Rs') }}. {{ $t('50000') }}
                                </label>
                                <br />
                                <label class="radio">
                                  <input
                                    v-model="salaryOptions"
                                    value="fifthOption"
                                    type="radio"
                                    :checked="salaryOptions === 'fifthOption'"
                                    name="salary"
                                    @change="getSalaryFilter(50001, '')"
                                  />
                                  {{ $t('Rs') }}. {{ $t('50000') }}+
                                </label>
                                <br />
                                <div
                                  class="columns is-multiline is-mobile is-vcentered is-desktop"
                                >
                                  <div class="column is-1">
                                    <label class="radio">
                                      <input
                                        v-model="salaryOptions"
                                        value="customOption"
                                        type="radio"
                                        name="salary"
                                    /></label>
                                  </div>
                                  <div class="column is-1 px-0">
                                    {{ $t('Rs') }}.
                                  </div>
                                  <div class="column is-4 pl-0">
                                    <input
                                      v-model="minimumSalary"
                                      min="0"
                                      :disabled="
                                        salaryOptions !== 'customOption'
                                      "
                                      :placeholder="$t('Minimum')"
                                      type="number"
                                      class="input is-small"
                                    />
                                  </div>
                                  <div class="column is-1 px-0">to</div>
                                  <div class="column is-4 pl-0">
                                    <input
                                      v-model="maximumSalary"
                                      min="0"
                                      :disabled="
                                        salaryOptions !== 'customOption'
                                      "
                                      :placeholder="$t('Maximum')"
                                      type="number"
                                      class="input is-small"
                                    />
                                  </div>
                                  <div class="column is-11 has-text-right py-0">
                                    <button
                                      v-if="salaryOptions === 'customOption'"
                                      class="button is-size-7 has-text-grey"
                                      :disabled="
                                        !maximumSalary && !minimumSalary
                                      "
                                      @click="
                                        getSalaryFilter(
                                          minimumSalary,
                                          maximumSalary
                                        )
                                      "
                                    >
                                      {{ $t('Apply Filter') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-list-ul')]"
                                ></vue-icon-base>
                                {{ $t('Job Type') }}
                              </label>
                              <div>
                                <auto-complete
                                  v-model="filterFields.job_type"
                                  :items="$options.availableForChoices"
                                  extra-input-class="is-small"
                                  item-text="name"
                                  item-value="value"
                                  allow-multiple
                                ></auto-complete>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-science')]"
                                ></vue-icon-base>
                                {{ $t('skills') }}
                              </label>
                              <div>
                                <vue-auto-complete
                                  v-model="filterFields.skills"
                                  item-text="name"
                                  extra-input-class="is-small"
                                  item-value="slug"
                                  endpoint="/api/v1/common/skills/"
                                  allow-multiple
                                ></vue-auto-complete>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-store-alt')]"
                                ></vue-icon-base>
                                {{ $t('industry') }}
                              </label>
                              <div>
                                <vue-auto-complete
                                  v-model="filterFields.industry"
                                  extra-input-class="is-small"
                                  item-text="name"
                                  item-value="slug"
                                  endpoint="/api/v1/common/industries"
                                  allow-multiple
                                ></vue-auto-complete>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div>
                    <div
                      class="pointer card-header-title is-size-6 has-text-weight-medium columns is-bottom-marginless is-bottom-paddingless"
                      @click="expansionControl('educationAndExperience')"
                    >
                      <div class="column is-10">
                        {{ $t('Education And Work Experience') }}
                      </div>
                      <div class="column is-2 has-text-right is-size-5">
                        <vue-icon-base
                          v-if="expansionController.educationAndExperience"
                          height="16"
                          width="16"
                          :path="$options.icons[$kc('uni-minus-circle')]"
                        ></vue-icon-base>
                        <vue-icon-base
                          v-else
                          height="16"
                          width="16"
                          :path="$options.icons[$kc('uni-plus-circle')]"
                        ></vue-icon-base>
                      </div>
                    </div>
                    <transition name="slide-fade">
                      <div v-show="expansionController.educationAndExperience">
                        <div
                          class="columns card-content is-multiline has-padding-top-10 has-padding-bottom-10"
                        >
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-book-open')]"
                                ></vue-icon-base>
                                {{ $t('Education') }}
                              </label>
                              <div>
                                <vue-auto-complete
                                  v-model="filterFields.education"
                                  extra-input-class="is-small"
                                  item-text="name"
                                  item-value="id"
                                  endpoint="/api/v1/common/education-degrees/"
                                ></vue-auto-complete>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-briefcase')]"
                                ></vue-icon-base>
                                {{ $t('Work Experience') }}
                              </label>
                              <div>
                                <auto-complete
                                  v-model="filterFields.experience_min"
                                  :items="$options.workExperienceChoices"
                                  extra-input-class="is-small"
                                  item-text="name"
                                  item-value="value"
                                ></auto-complete>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div>
                    <div
                      class="pointer card-header-title is-size-6 has-text-weight-medium columns is-bottom-marginless is-bottom-paddingless"
                      @click="expansionControl('otherInfo')"
                    >
                      <div class="column is-10">
                        {{ $t('Other Information') }}
                      </div>
                      <div class="column is-2 has-text-right is-size-5">
                        <vue-icon-base
                          v-if="expansionController.otherInfo"
                          height="16"
                          width="16"
                          :path="$options.icons[$kc('uni-minus-circle')]"
                        ></vue-icon-base>
                        <vue-icon-base
                          v-else
                          height="16"
                          width="16"
                          :path="$options.icons[$kc('uni-plus-circle')]"
                        ></vue-icon-base>
                      </div>
                    </div>
                    <transition name="slide-fade">
                      <div v-show="expansionController.otherInfo">
                        <div
                          class="columns card-content is-multiline has-padding-top-10 has-padding-bottom-10"
                        >
                          <div class="column is-12 px-2">
                            <div class="field">
                              <label
                                class="label has-text-grey has-text-weight-normal"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-mars')]"
                                ></vue-icon-base>
                                {{ $t('Gender') }}
                              </label>
                              <div>
                                <auto-complete
                                  v-model="filterFields.gender"
                                  :items="[
                                    ...$options.genderChoices,
                                    { name: 'No Preference', value: '' }
                                  ]"
                                  extra-input-class="is-small"
                                  item-text="name"
                                  item-value="value"
                                ></auto-complete>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div
                              class="field is-horizontal columns is-multiline is-mobile"
                            >
                              <label
                                class="has-text-grey has-text-weight-normal column"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-calender')]"
                                ></vue-icon-base>
                                {{ $t('Age Required') }}
                              </label>
                              <div class="column is-3 has-text-right">
                                <vue-switch v-model="filterAge" />
                              </div>
                              <div
                                v-if="filterAge"
                                class="column is-12 pt-0 has-text-grey"
                              >
                                <div
                                  class="control pl-5 is-size-8 has-text-grey"
                                >
                                  <label class="radio">
                                    <input
                                      v-model="ageOptions"
                                      value="firstOption"
                                      :checked="ageOptions === 'firstOption'"
                                      type="radio"
                                      name="age"
                                      @change="getAgeFilter(16, 25)"
                                    />
                                    {{ `${$t('16-25')} ${$t('Year')}` }}
                                  </label>
                                  <br />
                                  <label class="radio">
                                    <input
                                      v-model="ageOptions"
                                      value="secondOption"
                                      :checked="ageOptions === 'secondOption'"
                                      type="radio"
                                      name="age"
                                      @change="getAgeFilter(26, 35)"
                                    />
                                    {{ `${$t('26-35')} ${$t('Year')}` }}
                                  </label>
                                  <br />
                                  <label class="radio">
                                    <input
                                      v-model="ageOptions"
                                      value="thirdOption"
                                      type="radio"
                                      :checked="ageOptions === 'thirdOption'"
                                      name="age"
                                      @change="getAgeFilter(36, 50)"
                                    />
                                    {{ `${$t('36-50')} ${$t('Year')}` }}
                                  </label>
                                  <br />
                                  <label class="radio">
                                    <input
                                      v-model="ageOptions"
                                      type="radio"
                                      value="fourthOption"
                                      :checked="ageOptions === 'fourthOption'"
                                      name="age"
                                      @change="getAgeFilter(51, 0)"
                                    />
                                    {{ `${$t('50')} ${$t('Year')}` }} +
                                  </label>
                                  <br />
                                  <div
                                    class="columns is-multiline is-mobile is-vcentered is-desktop"
                                  >
                                    <div class="column is-1">
                                      <label class="radio">
                                        <input
                                          v-model="ageOptions"
                                          value="customOption"
                                          type="radio"
                                          name="age"
                                      /></label>
                                    </div>
                                    <div class="column is-4 pr-0">
                                      <input
                                        v-model="minimumAge"
                                        min="16"
                                        extra-input-class="is-small"
                                        :disabled="
                                          ageOptions !== 'customOption'
                                        "
                                        :placeholder="$t('Minimum')"
                                        type="number"
                                        class="input is-small"
                                      />
                                    </div>
                                    <div
                                      class="column is-1 px-0 has-text-centered"
                                    >
                                      to
                                    </div>
                                    <div class="column is-4 pl-0">
                                      <input
                                        v-model="maximumAge"
                                        min="16"
                                        extra-input-class="is-small"
                                        :disabled="
                                          ageOptions !== 'customOption'
                                        "
                                        :placeholder="$t('Maximum')"
                                        type="number"
                                        class="input is-small"
                                      />
                                    </div>
                                    <div
                                      class="column is-10 has-text-right py-0"
                                    >
                                      <button
                                        v-if="ageOptions === 'customOption'"
                                        class="button is-size-7 has-text-grey"
                                        :disabled="!maximumAge && !minimumAge"
                                        @click="
                                          getAgeFilter(minimumAge, maximumAge)
                                        "
                                      >
                                        {{ $t('Apply Filter') }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field is-horizontal columns is-mobile">
                              <label
                                class="label has-text-grey has-text-weight-normal column"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-clock')]"
                                ></vue-icon-base>
                                {{ $t('Urgently Required') }}
                              </label>
                              <div class="column is-3 has-text-right">
                                <vue-switch
                                  v-model="filterFields.urgently_required"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="column is-12 px-2">
                            <div class="field is-horizontal columns is-mobile">
                              <label
                                class="label has-text-grey has-text-weight-normal column"
                              >
                                <vue-icon-base
                                  height="16"
                                  width="16"
                                  :path="$options.icons[$kc('uni-bus-alt')]"
                                ></vue-icon-base>
                                {{ $t('Require Two Wheeler') }}
                              </label>
                              <div class="column is-3 has-text-right">
                                <vue-switch
                                  v-model="filterFields.two_wheeler"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </client-only>
        <div
          :class="{ 'is-active': showFilterInMobile && screen === 'mobile' }"
          class="modal"
          style="z-index: 100000"
        >
          <div
            class="detail-modal-background"
            @click="
              showFilterInMobile = false
              expansionController.expansion = false
            "
          ></div>
          <div class="card modal-width modal-border modal-active">
            <client-only>
              <div class="column is-4">
                <div class="card">
                  <div>
                    <div class="pointer card-header-title is-size-5">
                      <span
                        v-if="screen === 'mobile'"
                        class="is-size-6"
                        @click="showFilterInMobile = false"
                      >
                        {{ $t('Click here to refine search') }}
                      </span>
                      <a
                        v-if="showClearSearch && expansionController.expansion"
                        class="is-size-7 has-margin-left-auto"
                        @click="clearSearch"
                        >{{ $t('Clear Search') }}</a
                      >
                      <vue-icon-base
                        v-if="!expansionController.expansion"
                        class="has-margin-left-auto"
                        height="16"
                        width="16"
                        :path="$options.icons[$kc('uni-filter')]"
                      ></vue-icon-base>
                    </div>
                    <div
                      v-if="expansionController.expansion"
                      class="modal-height"
                    >
                      <div>
                        <div
                          class="pointer card-header-title is-size-6 has-text-weight-medium columns is-bottom-marginless is-bottom-paddingless"
                          @click="expansionControl('jobPreference')"
                        >
                          <div class="column is-10">
                            {{ $t('Job Preference') }}
                          </div>
                          <div class="column is-2 has-text-right is-size-5">
                            <vue-icon-base
                              v-if="expansionController.jobPreference"
                              height="16"
                              width="16"
                              :path="$options.icons[$kc('uni-minus-circle')]"
                            ></vue-icon-base>
                            <vue-icon-base
                              v-else
                              height="16"
                              width="16"
                              :path="$options.icons[$kc('uni-plus-circle')]"
                            ></vue-icon-base>
                          </div>
                        </div>
                        <transition name="slide-fade">
                          <div v-show="expansionController.jobPreference">
                            <div
                              class="columns card-content is-multiline has-padding-top-10 has-padding-bottom-10"
                            >
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-list-ui-alt')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('jobCategory') }}
                                  </label>
                                  <div>
                                    <vue-auto-complete
                                      v-model="filterFields.categories"
                                      extra-input-class="is-small"
                                      item-text="name"
                                      item-value="slug"
                                      endpoint="/api/v1/common/job-categories"
                                      allow-multiple
                                    ></vue-auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-list-ui-alt')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('Province') }}
                                  </label>
                                  <div>
                                    <vue-auto-complete
                                      v-model="filterFields.province"
                                      extra-input-class="is-small"
                                      :item-text="
                                        $i18n.locale == 'ne'
                                          ? 'name_ne'
                                          : 'name'
                                      "
                                      item-value="id"
                                      endpoint="/api/v1/common/province"
                                    ></vue-auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="filterFields.province"
                                class="column is-12 px-2"
                              >
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-list-ui-alt')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('District') }}
                                  </label>
                                  <div>
                                    <vue-auto-complete
                                      v-model="filterFields.district"
                                      extra-input-class="is-small"
                                      :item-text="
                                        $i18n.locale == 'ne'
                                          ? 'name_ne'
                                          : 'name'
                                      "
                                      item-value="id"
                                      endpoint="/api/v1/common/district"
                                      :extra-filter="{
                                        province: filterFields.province
                                      }"
                                    ></vue-auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="
                                  filterFields.province && filterFields.district
                                "
                                class="column is-12 px-2"
                              >
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-list-ui-alt')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('Municipality / VDC') }}
                                  </label>
                                  <div>
                                    <vue-auto-complete
                                      v-model="filterFields.locations"
                                      extra-input-class="is-small"
                                      :item-text="
                                        $i18n.locale == 'ne'
                                          ? 'name_ne'
                                          : 'name'
                                      "
                                      item-value="id"
                                      endpoint="/api/v1/common/cities/"
                                      :extra-filter="{
                                        district: filterFields.district
                                      }"
                                      filter-by="default_name"
                                    ></vue-auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="$options.icons[$kc('uni-sitemap')]"
                                    ></vue-icon-base>
                                    {{ $t('Job Level') }}
                                  </label>
                                  <div>
                                    <auto-complete
                                      v-model="filterFields.job_level"
                                      :items="$options.jobLevelChoices"
                                      item-text="name"
                                      extra-input-class="is-small"
                                      item-value="value"
                                      allow-multiple
                                    ></auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="$options.icons[$kc('uni-clock')]"
                                    ></vue-icon-base>
                                    {{ $t('Preferred Shift') }}
                                  </label>
                                  <div>
                                    <auto-complete
                                      v-model="filterFields.preferred_shift"
                                      extra-input-class="is-small"
                                      :items="$options.preferredShitChoices"
                                      item-text="name"
                                      item-value="value"
                                      allow-multiple
                                    ></auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-money-bill')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('Expected Salary') }}
                                  </label>
                                  <div
                                    class="control pl-5 is-size-8 has-text-grey"
                                  >
                                    <label class="radio">
                                      <input
                                        v-model="salaryOptions"
                                        value="firstOption"
                                        :checked="
                                          salaryOptions === 'firstOption'
                                        "
                                        type="radio"
                                        name="salary"
                                        @change="getSalaryFilter(0, 15000)"
                                      />
                                      {{
                                        `${$t('Rs')}. ${$t('15000')} ${$t(
                                          'or less'
                                        )}`
                                      }}
                                    </label>
                                    <br />
                                    <label class="radio">
                                      <input
                                        v-model="salaryOptions"
                                        value="secondOption"
                                        :checked="
                                          salaryOptions === 'secondOption'
                                        "
                                        type="radio"
                                        name="salary"
                                        @change="getSalaryFilter(15001, 25000)"
                                      />
                                      {{ $t('Rs') }}. {{ $t('15001') }} -
                                      {{ $t('Rs') }}. {{ $t('25000') }}
                                    </label>
                                    <br />
                                    <label class="radio">
                                      <input
                                        v-model="salaryOptions"
                                        value="thirdOption"
                                        type="radio"
                                        :checked="
                                          salaryOptions === 'thirdOption'
                                        "
                                        name="salary"
                                        @change="getSalaryFilter(25001, 35000)"
                                      />
                                      {{ $t('Rs') }}. {{ $t('25001') }} -
                                      {{ $t('Rs') }}. {{ $t('35000') }}
                                    </label>
                                    <br />
                                    <label class="radio">
                                      <input
                                        v-model="salaryOptions"
                                        type="radio"
                                        value="fourthOption"
                                        :checked="
                                          salaryOptions === 'fourthOption'
                                        "
                                        name="salary"
                                        @change="getSalaryFilter(35001, 50000)"
                                      />
                                      {{ $t('Rs') }}. {{ $t('35001') }} -
                                      {{ $t('Rs') }}. {{ $t('50000') }}
                                    </label>
                                    <br />
                                    <label class="radio">
                                      <input
                                        v-model="salaryOptions"
                                        value="fifthOption"
                                        type="radio"
                                        :checked="
                                          salaryOptions === 'fifthOption'
                                        "
                                        name="salary"
                                        @change="getSalaryFilter(50001, '')"
                                      />
                                      {{ $t('Rs') }}. {{ $t('50000') }}+
                                    </label>
                                    <br />
                                    <div
                                      class="columns is-multiline is-mobile is-vcentered is-desktop"
                                    >
                                      <div class="column is-1">
                                        <label class="radio">
                                          <input
                                            v-model="salaryOptions"
                                            value="customOption"
                                            type="radio"
                                            name="salary"
                                        /></label>
                                      </div>
                                      <div class="column is-1 px-0">
                                        {{ $t('Rs') }}.
                                      </div>
                                      <div class="column is-4 pl-0">
                                        <input
                                          v-model="minimumSalary"
                                          min="0"
                                          :disabled="
                                            salaryOptions !== 'customOption'
                                          "
                                          :placeholder="$t('Minimum')"
                                          type="number"
                                          class="input is-small"
                                        />
                                      </div>
                                      <div class="column is-1 px-0">to</div>
                                      <div class="column is-4 pl-0">
                                        <input
                                          v-model="maximumSalary"
                                          min="0"
                                          :disabled="
                                            salaryOptions !== 'customOption'
                                          "
                                          :placeholder="$t('Maximum')"
                                          type="number"
                                          class="input is-small"
                                        />
                                      </div>
                                      <div
                                        class="column is-11 has-text-right py-0"
                                      >
                                        <button
                                          v-if="
                                            salaryOptions === 'customOption'
                                          "
                                          class="button is-size-7 has-text-grey"
                                          :disabled="
                                            !maximumSalary && !minimumSalary
                                          "
                                          @click="
                                            getSalaryFilter(
                                              minimumSalary,
                                              maximumSalary
                                            )
                                          "
                                        >
                                          {{ $t('Apply Filter') }}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="$options.icons[$kc('uni-list-ul')]"
                                    ></vue-icon-base>
                                    {{ $t('Job Type') }}
                                  </label>
                                  <div>
                                    <auto-complete
                                      v-model="filterFields.job_type"
                                      :items="$options.availableForChoices"
                                      extra-input-class="is-small"
                                      item-text="name"
                                      item-value="value"
                                      allow-multiple
                                    ></auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="$options.icons[$kc('uni-science')]"
                                    ></vue-icon-base>
                                    {{ $t('skills') }}
                                  </label>
                                  <div>
                                    <vue-auto-complete
                                      v-model="filterFields.skills"
                                      item-text="name"
                                      extra-input-class="is-small"
                                      item-value="slug"
                                      endpoint="/api/v1/common/skills/"
                                      allow-multiple
                                    ></vue-auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-store-alt')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('industry') }}
                                  </label>
                                  <div>
                                    <vue-auto-complete
                                      v-model="filterFields.industry"
                                      extra-input-class="is-small"
                                      item-text="name"
                                      item-value="slug"
                                      endpoint="/api/v1/common/industries"
                                      allow-multiple
                                    ></vue-auto-complete>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                      <div>
                        <div
                          class="pointer card-header-title is-size-6 has-text-weight-medium columns is-bottom-marginless is-bottom-paddingless"
                          @click="expansionControl('educationAndExperience')"
                        >
                          <div class="column is-10">
                            {{ $t('Education And Work Experience') }}
                          </div>
                          <div class="column is-2 has-text-right is-size-5">
                            <vue-icon-base
                              v-if="expansionController.educationAndExperience"
                              height="16"
                              width="16"
                              :path="$options.icons[$kc('uni-minus-circle')]"
                            ></vue-icon-base>
                            <vue-icon-base
                              v-else
                              height="16"
                              width="16"
                              :path="$options.icons[$kc('uni-plus-circle')]"
                            ></vue-icon-base>
                          </div>
                        </div>
                        <transition name="slide-fade">
                          <div
                            v-show="expansionController.educationAndExperience"
                          >
                            <div
                              class="columns card-content is-multiline has-padding-top-10 has-padding-bottom-10"
                            >
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-book-open')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('Education') }}
                                  </label>
                                  <div>
                                    <vue-auto-complete
                                      v-model="filterFields.education"
                                      extra-input-class="is-small"
                                      item-text="name"
                                      item-value="id"
                                      endpoint="/api/v1/common/education-degrees/"
                                    ></vue-auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-briefcase')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('Work Experience') }}
                                  </label>
                                  <div>
                                    <auto-complete
                                      v-model="filterFields.experience_min"
                                      :items="$options.workExperienceChoices"
                                      extra-input-class="is-small"
                                      item-text="name"
                                      item-value="value"
                                    ></auto-complete>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                      <div>
                        <div
                          class="pointer card-header-title is-size-6 has-text-weight-medium columns is-bottom-marginless is-bottom-paddingless"
                          @click="expansionControl('otherInfo')"
                        >
                          <div class="column is-10">
                            {{ $t('Other Information') }}
                          </div>
                          <div class="column is-2 has-text-right is-size-5">
                            <vue-icon-base
                              v-if="expansionController.otherInfo"
                              height="16"
                              width="16"
                              :path="$options.icons[$kc('uni-minus-circle')]"
                            ></vue-icon-base>
                            <vue-icon-base
                              v-else
                              height="16"
                              width="16"
                              :path="$options.icons[$kc('uni-plus-circle')]"
                            ></vue-icon-base>
                          </div>
                        </div>
                        <transition name="slide-fade">
                          <div v-show="expansionController.otherInfo">
                            <div
                              class="columns card-content is-multiline has-padding-top-10 has-padding-bottom-10"
                            >
                              <div class="column is-12 px-2">
                                <div class="field">
                                  <label
                                    class="label has-text-grey has-text-weight-normal"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="$options.icons[$kc('uni-mars')]"
                                    ></vue-icon-base>
                                    {{ $t('Gender') }}
                                  </label>
                                  <div>
                                    <auto-complete
                                      v-model="filterFields.gender"
                                      :items="[
                                        ...$options.genderChoices,
                                        { name: 'No Preference', value: '' }
                                      ]"
                                      extra-input-class="is-small"
                                      item-text="name"
                                      item-value="value"
                                    ></auto-complete>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div
                                  class="field is-horizontal columns is-multiline is-mobile"
                                >
                                  <label
                                    class="has-text-grey has-text-weight-normal column"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="
                                        $options.icons[$kc('uni-calender')]
                                      "
                                    ></vue-icon-base>
                                    {{ $t('Age Required') }}
                                  </label>
                                  <div class="column is-3 has-text-right">
                                    <vue-switch v-model="filterAge" />
                                  </div>
                                  <div
                                    v-if="filterAge"
                                    class="column is-12 pt-0 has-text-grey"
                                  >
                                    <div
                                      class="control pl-5 is-size-8 has-text-grey"
                                    >
                                      <label class="radio">
                                        <input
                                          v-model="ageOptions"
                                          value="firstOption"
                                          :checked="
                                            ageOptions === 'firstOption'
                                          "
                                          type="radio"
                                          name="age"
                                          @change="getAgeFilter(16, 25)"
                                        />
                                        {{ `${$t('16-25')} ${$t('Year')}` }}
                                      </label>
                                      <br />
                                      <label class="radio">
                                        <input
                                          v-model="ageOptions"
                                          value="secondOption"
                                          :checked="
                                            ageOptions === 'secondOption'
                                          "
                                          type="radio"
                                          name="age"
                                          @change="getAgeFilter(26, 35)"
                                        />
                                        {{ `${$t('26-35')} ${$t('Year')}` }}
                                      </label>
                                      <br />
                                      <label class="radio">
                                        <input
                                          v-model="ageOptions"
                                          value="thirdOption"
                                          type="radio"
                                          :checked="
                                            ageOptions === 'thirdOption'
                                          "
                                          name="age"
                                          @change="getAgeFilter(36, 50)"
                                        />
                                        {{ `${$t('36-50')} ${$t('Year')}` }}
                                      </label>
                                      <br />
                                      <label class="radio">
                                        <input
                                          v-model="ageOptions"
                                          type="radio"
                                          value="fourthOption"
                                          :checked="
                                            ageOptions === 'fourthOption'
                                          "
                                          name="age"
                                          @change="getAgeFilter(51, 0)"
                                        />
                                        {{ `${$t('50')} ${$t('Year')}` }} +
                                      </label>
                                      <br />
                                      <div
                                        class="columns is-multiline is-mobile is-vcentered is-desktop"
                                      >
                                        <div class="column is-1">
                                          <label class="radio">
                                            <input
                                              v-model="ageOptions"
                                              value="customOption"
                                              type="radio"
                                              name="age"
                                          /></label>
                                        </div>
                                        <div class="column is-4 pr-0">
                                          <input
                                            v-model="minimumAge"
                                            min="16"
                                            extra-input-class="is-small"
                                            :disabled="
                                              ageOptions !== 'customOption'
                                            "
                                            :placeholder="$t('Minimum')"
                                            type="number"
                                            class="input is-small"
                                          />
                                        </div>
                                        <div
                                          class="column is-1 px-0 has-text-centered"
                                        >
                                          to
                                        </div>
                                        <div class="column is-4 pl-0">
                                          <input
                                            v-model="maximumAge"
                                            min="16"
                                            extra-input-class="is-small"
                                            :disabled="
                                              ageOptions !== 'customOption'
                                            "
                                            :placeholder="$t('Maximum')"
                                            type="number"
                                            class="input is-small"
                                          />
                                        </div>
                                        <div
                                          class="column is-10 has-text-right py-0"
                                        >
                                          <button
                                            v-if="ageOptions === 'customOption'"
                                            class="button is-size-7 has-text-grey"
                                            :disabled="
                                              !maximumAge && !minimumAge
                                            "
                                            @click="
                                              getAgeFilter(
                                                minimumAge,
                                                maximumAge
                                              )
                                            "
                                          >
                                            {{ $t('Apply Filter') }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div
                                  class="field is-horizontal columns is-mobile"
                                >
                                  <label
                                    class="label has-text-grey has-text-weight-normal column"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="$options.icons[$kc('uni-clock')]"
                                    ></vue-icon-base>
                                    {{ $t('Urgently Required') }}
                                  </label>
                                  <div class="column is-3 has-text-right">
                                    <vue-switch
                                      v-model="filterFields.urgently_required"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="column is-12 px-2">
                                <div
                                  class="field is-horizontal columns is-mobile"
                                >
                                  <label
                                    class="label has-text-grey has-text-weight-normal column"
                                  >
                                    <vue-icon-base
                                      height="16"
                                      width="16"
                                      :path="$options.icons[$kc('uni-bus-alt')]"
                                    ></vue-icon-base>
                                    {{ $t('Require Two Wheeler') }}
                                  </label>
                                  <div class="column is-3 has-text-right">
                                    <vue-switch
                                      v-model="filterFields.two_wheeler"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </client-only>
          </div>
        </div>
        <div class="column is-8">
          <div v-if="filterFields.tags" class="is-size-7 is-grey pb-2">
            Filtered by
            <strong class="tag is-light is-rounded">
              {{ activeTag.name }}
              <button class="delete is-small" @click="filterByTags()"></button>
            </strong>
          </div>
          <div
            v-if="
              get($store.state.collection.collectionResponses, [
                'jobSearchCollection',
                'count'
              ]) > 0 && !loading
            "
          >
            <job-preview
              collection-name="jobSearchCollection"
              class="mb-3"
              show-tags
              @selectedTag="filterByTags($event)"
            ></job-preview>
            <pagination
              v-model="paginationController.page"
              collection-name="jobSearchCollection"
              :page-size="paginationController.itemsPerPage"
              @scroll="scrollTop"
            ></pagination>
          </div>
          <div v-else>
            <vue-no-data :loading="loading"></vue-no-data>
          </div>
        </div>
      </div>
    </div>
    <footer
      v-if="screen === 'mobile'"
      class="footer-nav is-size-6"
      :class="{
        sticky: isFooterSticky && screen === 'mobile'
      }"
      @click="
        showFilterInMobile = true
        expansionController.expansion = true
      "
    >
      <div class="pointer card-header-title is-size-5 py-4 outline">
        <span @click="expansionControl('expansion')">
          {{ $t('Click here to refine search') }}
        </span>
        <a
          v-if="showClearSearch && expansionController.expansion"
          class="is-size-7 has-margin-left-auto"
          @click="clearSearch"
          >{{ $t('Clear Search') }}</a
        >
        <vue-icon-base
          class="has-margin-left-auto"
          height="16"
          width="16"
          :path="$options.icons[$kc('uni-filter')]"
        ></vue-icon-base>
      </div>
    </footer>
  </div>
</template>
<script>
// import HomepageFilter from '@/components/Job/HomepageFilter'
import JobPreview from '@/components/Job/JobPreview'
import Pagination from '@/components/Commons/Pagination'
import VueAutoComplete from '@/components/Commons/VueAutoComplete'
import AutoComplete from '@/components/Commons/AutoComplete'
// import RangeSlider from '@/components/Commons/RangeSlider'
import VueSwitch from '@/components/Commons/VueSwitch'
import VueNoData from '@/components/Commons/VueNoData'
import { scrollToContent } from '@/helpers/utils/common.js'

import { getResouceUrl } from '@/helpers/utils/searchUtils'
import {
  preferredShitChoices,
  provinceBanner
} from '@/helpers/constants/common'
import {
  availableForChoices,
  genderChoices,
  jobLevelChoices,
  workExperienceChoices
} from '@/helpers/constants/jobseeker'
import VueIconBase from '@/components/Commons/VueIconBase'
import { mapGetters } from 'vuex'
import {
  uniMinusCircle,
  uniPlusCircle,
  uniListUiAlt,
  uniScience,
  uniClock,
  uniMoneyBill,
  uniListUl,
  uniSitemap,
  uniBookOpen,
  uniBriefcase,
  uniCalender,
  uniBusAlt,
  uniMars,
  uniUserCircle,
  // uniTagAlt,
  uniStoreAlt,
  uniFilter
} from '@/helpers/icons'

export default {
  icons: {
    uniMinusCircle,
    uniPlusCircle,
    uniListUiAlt,
    uniScience,
    uniClock,
    uniMoneyBill,
    uniListUl,
    uniSitemap,
    uniBookOpen,
    uniBriefcase,
    uniCalender,
    uniBusAlt,
    uniMars,
    uniUserCircle,
    // uniTagAlt,
    uniStoreAlt,
    uniFilter
  },
  preferredShitChoices,
  jobLevelChoices,
  genderChoices,
  workExperienceChoices,
  availableForChoices,
  provinceBanner,
  components: {
    VueIconBase,
    // HomepageFilter,
    JobPreview,
    Pagination,
    VueAutoComplete,
    AutoComplete,
    // RangeSlider,
    VueSwitch,
    VueNoData
  },
  async asyncData({ params, store, $axios, route }) {
    const itemsPerPage = 7
    const filterFields = Object.assign({}, route.query)
    const paginationFields = {
      limit: itemsPerPage
    }
    const contentUrl = '/api/v1/job/search/'
    const resourceUrl = getResouceUrl(contentUrl, {
      ...paginationFields,
      ...filterFields
    })
    const { data } = await $axios.get(resourceUrl)

    store.commit('collection/setCollectionData', ['jobSearchCollection', data])

    // const homepageJobsUrl = '/api/v1/job/home-page-jobs/'

    // const homePageJobsData = await $axios.get(homepageJobsUrl)

    // store.commit('collection/setCollectionData', [
    //   'homePageJobs',
    //   homePageJobsData.data
    // ])
    // store.commit('collection/changeHomePageFilterFor', 'job')

    return {
      contentUrl,
      paginationFields,
      filterFields,
      paginationController: {
        page: 1,
        itemsPerPage
      },
      totalCount: data ? data.count : 0
    }
  },
  data() {
    return {
      isFooterSticky: false,
      showFilterInMobile: false,
      showProvince: false,
      expansionController: {
        jobPreference: true,
        educationAndExperience: false,
        otherInfo: false,
        expansion: true
      },
      minimumSalary: '',
      maximumSalary: '',
      salaryOptions: '',
      minimumAge: '',
      maximumAge: '',
      ageOptions: '',
      loading: false,
      filterAge: false,
      activeTag: '',
      provinceObject: {}
    }
  },
  scrollToContent,
  computed: {
    ...mapGetters({
      screen: 'getScreen'
    }),
    showClearSearch() {
      const filterFieldsCopy = { ...this.filterFields }
      delete filterFieldsCopy.search
      delete filterFieldsCopy.limit
      return Object.values(filterFieldsCopy).some(value => !!value)
    },
    noOfVacancyForJobPost() {
      return this.get(this.$store.state.collection.collectionResponses, [
        'jobSearchCollection',
        'total_vacancies'
      ])
    }
  },
  watch: {
    'paginationController.page': {
      handler(newVal) {
        this.$set(
          this.paginationFields,
          'offset',
          this.paginationController.itemsPerPage * (newVal - 1)
        )
        this.$set(
          this.paginationFields,
          'limit',
          this.paginationController.itemsPerPage
        )
        this.getData()
      }
    },
    '$route.query': {
      handler(newVal) {
        this.filterFields = Object.assign(this.filterFields, this.$route.query)
      },
      deep: true
    },
    paginationFields: {
      handler() {
        window.history.pushState(
          'page2',
          'Title',
          getResouceUrl(
            '',
            { ...this.filterFields, ...this.paginationFields },
            ['experience_min']
          )
        )
        this.getData()
      },
      deep: true
    },
    filterFields: {
      handler() {
        if (this.filterFields.province) {
          this.provinceObjects()
        } else {
          this.showProvince = false
        }
        window.history.pushState(
          'page2',
          'Title',
          getResouceUrl(
            '',
            { ...this.filterFields, ...this.paginationFields },
            ['experience_min']
          )
        )
        this.scrollTop()
        this.paginationController.page = 1
        this.$set(this.paginationFields, 'offset', 0)
        this.getData()
      },
      deep: true
    },
    salaryOptions(val) {
      if (val !== 'customOption') {
        this.maximumSalary = ''
        this.minimumSalary = ''
      }
    },
    ageOptions(val) {
      if (val !== 'customOption') {
        this.maximumAge = ''
        this.minimumAge = ''
      }
    },
    filterAge(val) {
      if (!val) {
        this.filterFields.age_min = 0
        this.filterFields.age_max = 0
      }
    }
  },
  mounted() {
    this.provinceObjects()
    this.calculateCurrentPage()
    if (window.innerWidth < 500) {
      this.expansionController.expansion = false
    }
    if (this.$route.query.province) {
      this.showProvince = true
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const scroll = window.pageYOffset || document.documentElement.scrollTop

      if (scroll > 50) {
        this.isFooterSticky = true
      } else {
        this.isFooterSticky = false
      }
    },
    async getData() {
      if (this.loading) return
      this.loading = true
      const resourceUrl = getResouceUrl(
        this.contentUrl,
        {
          ...this.filterFields,
          ...this.paginationFields
        },
        ['experience_min']
      )
      const { data } = await this.$axios.get(resourceUrl)
      this.$store.commit('collection/setCollectionData', [
        'jobSearchCollection',
        data
      ])
      this.loading = false
    },
    getSalaryFilter(min, max) {
      this.filterFields.salary_min = min
      this.filterFields.salary_max = max
      window.history.pushState(
        'page2',
        'Title',
        getResouceUrl('', { ...this.filterFields, ...this.paginationFields }, [
          'experience_min'
        ])
      )
      this.scrollTop()
      this.paginationController.page = 1
      this.getData()
    },
    filterByTags(item) {
      this.activeTag = item
      this.filterFields.tags = ''
      if (item) {
        this.filterFields.tags = item.slug
      }
      window.history.pushState(
        'page2',
        'Title',
        getResouceUrl('', { ...this.filterFields, ...this.paginationFields }, [
          'experience_min'
        ])
      )
      this.scrollTop()
      this.paginationController.page = 1
      this.getData()
    },
    getAgeFilter(min, max) {
      this.filterFields.age_min = min
      this.filterFields.age_max = max
      window.history.pushState(
        'page2',
        'Title',
        getResouceUrl('', { ...this.filterFields, ...this.paginationFields }, [
          'experience_min'
        ])
      )
      this.scrollTop()
      this.paginationController.page = 1
      this.getData()
    },
    calculateCurrentPage() {
      const limit = this.$route.query.limit || 7
      const offset = this.$route.query.offset || 0
      if (limit && offset >= 0) {
        this.paginationController.page = Math.floor(offset / limit) + 1
      }
    },
    expansionControl(section) {
      if (this.expansionController[section]) {
        this.expansionController[section] = false
      } else if (section === 'expansion') {
        this.expansionController.expansion = true
      } else {
        this.expansionController.jobPreference = false
        this.expansionController.educationAndExperience = false
        this.expansionController.otherInfo = false
        this.expansionController[section] = true
      }
    },
    scrollTop() {
      if (!this.loading) {
        setTimeout(() => {
          this.$options.scrollToContent('job-lists')
        }, 200)
      }
    },
    clearSearch() {
      this.filterFields = {}
      this.salaryOptions = ''
      this.minimumSalary = ''
      this.maximumSalary = ''
      this.ageOptions = ''
      this.minimumAge = ''
      this.maximumAge = ''
    },
    async provinceObjects() {
      const provinceId =
        this.$route.query.province || this.filterFields.province
      this.provinceObject = await provinceBanner.find(
        item => item.id === parseInt(provinceId)
      )
      if (this.$route.query.province || this.filterFields.province) {
        this.showProvince = true
        this.$route.query.province = null
      }
    }
  },
  head() {
    return {
      title: 'Search Jobs - Vacancy in Nepal | Rojgari'
    }
  }
}
</script>
<style scoped>
.banner {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: top;
}
.text-color h3,
p {
  color: #895001;
}
.map img {
  height: 200px;
}
.is-size-8 {
  font-size: 0.85rem;
}
.z-index {
  z-index: 1;
  margin: auto;
  padding: 0;
}
.footer-nav {
  position: fixed;
  z-index: 999;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 12px;
  font-family: Arial, sans-serif;
  font-weight: normal;
  color: #fff;
  text-align: center;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.footer-nav.hidden {
  opacity: 0;
  transform: translateY(100%);
}
.footer-nav.sticky {
  position: fixed;
  bottom: 0;
}
.detail-modal-background {
  background-color: rgba(10, 10, 10, 0.2);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.placecontent-end {
  place-content: end;
}
@media only screen and (max-width: 768px) {
  .modal-width {
    max-height: 90vh;
    bottom: 0;
    position: absolute;
  }
  .modal-height {
    padding: 0 !important;
    height: 65vh;
    overflow: auto;
  }
  .previous-button-width {
    width: 28%;
  }
  .button-width {
    width: 70%;
  }
  .has-text-center {
    text-align: center !important;
  }
}
@media only screen and (min-width: 769px) {
  .modal-width {
    position: absolute;
    height: auto;
  }
  .modal-height {
    height: 80vh;
  }
  .has-text-center {
    text-align: right !important;
  }
}
</style>
